import type { AxiosInstance } from 'axios'
import * as R from 'ramda'
import URI from 'urijs'

import { CategoryListInterface } from '../../interfaces/category'

// A endpoint just to get all categories for the multiselector
export const getAllCategories = (api: AxiosInstance) => async (): Promise<
  CategoryListInterface[]
> => {
  const { data } = await api.get(
    '/v1.0/admin/categories?' +
      URI.buildQuery({
        page: 1,
        limit: 100
      })
  )
  return R.propOr([], 'result', data)
}
